<template>
    <div>
        <AutoModeIndicator v-if="$store.autoModeEnabled" />
        <router-view></router-view>
    </div>
</template>

<script lang="ts">
import { Watch, Component, Vue } from "vue-property-decorator";
import AutoModeIndicator from "@/components/AutoMode/AutoModeIndicator.vue";

@Component({
    name: "App",
    components: {
        AutoModeIndicator
    }
})
export default class App extends Vue {

    @Watch("$route", { immediate: true })
    routeUpdate(to: any, _from: any) {
        let title = to.meta.title;
        if (title == "Print Queue") title = this.$pageNames.printQueue;
        if (title == "Stale Print Queue") title = this.$pageNames.stalePrintQueue;
        document.title = title || "Scriptly";
    }

}
</script>
